import { observable, computed, action } from 'mobx';




// 状态管理
class RootStore {
  wxappid = 'wxf0d70f6da7614f98'
  secret = '6d1ef5be4f4fa84cc298809bfdac4c30'
  //the rootUrl is used for QRCode report url
  rootUrl = 'http://customer.tyrehubtech.com/'
  // rootUrl = 'http://customer.taihapo.com.cn/'
  // rootUrl='https://customer.test.taihapo.com.cn/'
  //rootUrl='http://customer.iptirescanner.com/'
  Merchant = '1587676421'//商户号  
  @observable user = null
  @observable openid = ''
  @observable is_auth = false

  @action
  updateUser(user, openid, callback) {

    this.openid = openid
    this.user = user
    callback && callback();
  }


  @action
  updateauth(is_auth, callback) {
    this.is_auth = is_auth
    callback && callback();
  }

  @action
  updateOpenId(openid, callback) {
    this.openid = openid
    callback && callback();
  }

  @action
  updateUserObject(user, callback) {
    this.user = user
    callback && callback();
  }

  //获得携带的参数
  getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]); return null;
  }

  isMobileNumber(phone) {
    let flag = false;
    let message = "";
    let myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;
    if (phone == '') {
      // console.log("手机号码不能为空");
      message = "手机号码不能为空！";
    } else if (phone.length != 11) {
      //console.log("请输入11位手机号码！");
      message = "请输入11位手机号码！";
    } else if (!myreg.test(phone)) {
      //console.log("请输入有效的手机号码！");
      message = "请输入有效的手机号码！";
    } else {
      flag = true;
    }
    if (message != "") {
      alert(message);
    }
    return flag;
  }

}

export default new RootStore();



// WEBPACK FOOTER //
// ./src/store/store.js